var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2224 25.33C14.961 25.33 13.9197 25.0073 13.0984 24.362C12.2844 23.7167 11.705 22.844 11.3604 21.744L14.3084 21.04C14.3744 21.4433 14.587 21.7953 14.9464 22.096C15.3057 22.3893 15.687 22.536 16.0904 22.536C16.369 22.536 16.666 22.459 16.9814 22.305C17.304 22.151 17.535 21.9053 17.6744 21.568C17.7624 21.3553 17.8137 21.095 17.8284 20.787C17.843 20.479 17.8504 20.1233 17.8504 19.72V9.16H20.8864V19.72C20.8864 20.226 20.8827 20.666 20.8754 21.04C20.8754 21.414 20.8387 21.766 20.7654 22.096C20.6994 22.4187 20.5637 22.756 20.3584 23.108C19.911 23.8853 19.328 24.45 18.6094 24.802C17.8907 25.154 17.095 25.33 16.2224 25.33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 34.0033C14.534 29.7134 8.25 31.392 8.25 35.6074C8.25 40.3449 14.7727 42.0236 16.9601 46.4254L16.9999 46.5L17.0397 46.4254C19.2272 42.0236 25.7498 40.3449 25.7498 35.6074C25.7896 31.392 19.4658 29.7134 16.9999 34.0033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 50.0059C32.5612 42.2841 21.25 45.3057 21.25 52.8932C21.25 61.4208 32.9908 64.4424 36.9282 72.3657L36.9998 72.5L37.0714 72.3657C41.0089 64.4424 52.7497 61.4208 52.7497 52.8932C52.8213 45.3057 41.4384 42.2841 36.9998 50.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJh);
export default __webpack_public_path__ + "static/media/jh.8bfa7f7c09e7a8ef23f66b924b1a80cc.svg";
export { ForwardRef as ReactComponent };